export default {
    // --- Most likely to be reported by real browsers (CLDR/ICU legacy names) ---
    'Asia/Calcutta'        : 'Asia/Kolkata',
    'Asia/Katmandu'        : 'Asia/Kathmandu',
    'Asia/Rangoon'         : 'Asia/Yangon',
    'Asia/Saigon'          : 'Asia/Ho_Chi_Minh',
    'Europe/Kiev'          : 'Europe/Kyiv',
    'America/Buenos_Aires' : 'America/Argentina/Buenos_Aires',
    'America/Catamarca'    : 'America/Argentina/Catamarca',
    'America/Cordoba'      : 'America/Argentina/Cordoba',
    'America/Jujuy'        : 'America/Argentina/Jujuy',
    'America/Mendoza'      : 'America/Argentina/Mendoza',
    'America/Indianapolis' : 'America/Indiana/Indianapolis',
    'America/Louisville'   : 'America/Kentucky/Louisville',
    'America/Godthab'      : 'America/Nuuk',
    'America/Coral_Harbour' : 'America/Atikokan',
    'Atlantic/Faeroe'      : 'Atlantic/Faroe',
    'Pacific/Truk'         : 'Pacific/Chuuk',
    'Pacific/Ponape'       : 'Pacific/Pohnpei',
    'Pacific/Enderbury'    : 'Pacific/Kanton',

    // --- Africa ---
    'Africa/Asmera'        : 'Africa/Asmara',
    'Africa/Timbuktu'      : 'Africa/Bamako',

    // --- America ---
    'America/Argentina/ComodRivadavia' : 'America/Argentina/Catamarca',
    'America/Atka'         : 'America/Adak',
    'America/Ensenada'     : 'America/Tijuana',
    'America/Fort_Wayne'   : 'America/Indiana/Indianapolis',
    'America/Knox_IN'      : 'America/Indiana/Knox',
    'America/Montreal'     : 'America/Toronto',
    'America/Porto_Acre'   : 'America/Rio_Branco',
    'America/Rosario'      : 'America/Argentina/Cordoba',
    'America/Santa_Isabel' : 'America/Tijuana',
    'America/Shiprock'     : 'America/Denver',
    'America/Virgin'       : 'America/St_Thomas',

    // --- Antarctica ---
    'Antarctica/South_Pole' : 'Antarctica/McMurdo',

    // --- Asia ---
    'Asia/Ashkhabad'       : 'Asia/Ashgabat',
    'Asia/Chongqing'       : 'Asia/Shanghai',
    'Asia/Chungking'       : 'Asia/Shanghai',
    'Asia/Dacca'           : 'Asia/Dhaka',
    'Asia/Harbin'          : 'Asia/Shanghai',
    'Asia/Istanbul'        : 'Europe/Istanbul',
    'Asia/Kashgar'         : 'Asia/Urumqi',
    'Asia/Macao'           : 'Asia/Macau',
    'Asia/Tel_Aviv'        : 'Asia/Jerusalem',
    'Asia/Thimbu'          : 'Asia/Thimphu',
    'Asia/Ujung_Pandang'   : 'Asia/Makassar',
    'Asia/Ulan_Bator'      : 'Asia/Ulaanbaatar',

    // --- Australia ---
    'Australia/ACT'        : 'Australia/Sydney',
    'Australia/Canberra'   : 'Australia/Sydney',
    'Australia/LHI'        : 'Australia/Lord_Howe',
    'Australia/NSW'        : 'Australia/Sydney',
    'Australia/North'      : 'Australia/Darwin',
    'Australia/Queensland' : 'Australia/Brisbane',
    'Australia/South'      : 'Australia/Adelaide',
    'Australia/Tasmania'   : 'Australia/Hobart',
    'Australia/Victoria'   : 'Australia/Melbourne',
    'Australia/West'       : 'Australia/Perth',
    'Australia/Yancowinna' : 'Australia/Broken_Hill',

    // --- Brazil ---
    'Brazil/Acre'          : 'America/Rio_Branco',
    'Brazil/DeNoronha'     : 'America/Noronha',
    'Brazil/East'          : 'America/Sao_Paulo',
    'Brazil/West'          : 'America/Manaus',

    // --- Canada ---
    'Canada/Atlantic'      : 'America/Halifax',
    'Canada/Central'       : 'America/Winnipeg',
    'Canada/Eastern'       : 'America/Toronto',
    'Canada/Mountain'      : 'America/Edmonton',
    'Canada/Newfoundland'  : 'America/St_Johns',
    'Canada/Pacific'       : 'America/Vancouver',
    'Canada/Saskatchewan'  : 'America/Regina',
    'Canada/Yukon'         : 'America/Whitehorse',

    // --- Chile ---
    'Chile/Continental'    : 'America/Santiago',
    'Chile/EasterIsland'   : 'Pacific/Easter',

    // --- Europe ---
    'Europe/Belfast'       : 'Europe/London',
    'Europe/Nicosia'       : 'Asia/Nicosia',
    'Europe/Tiraspol'      : 'Europe/Chisinau',

    // --- Mexico ---
    'Mexico/BajaNorte'     : 'America/Tijuana',
    'Mexico/BajaSur'       : 'America/Mazatlan',
    'Mexico/General'       : 'America/Mexico_City',

    // --- Pacific ---
    'Pacific/Johnston'     : 'Pacific/Honolulu',
    'Pacific/Samoa'        : 'Pacific/Pago_Pago',
    'Pacific/Yap'          : 'Pacific/Chuuk',

    // --- US ---
    'US/Alaska'            : 'America/Anchorage',
    'US/Aleutian'          : 'America/Adak',
    'US/Arizona'           : 'America/Phoenix',
    'US/Central'           : 'America/Chicago',
    'US/East-Indiana'      : 'America/Indiana/Indianapolis',
    'US/Eastern'           : 'America/New_York',
    'US/Hawaii'            : 'Pacific/Honolulu',
    'US/Indiana-Starke'    : 'America/Indiana/Knox',
    'US/Michigan'          : 'America/Detroit',
    'US/Mountain'          : 'America/Denver',
    'US/Pacific'           : 'America/Los_Angeles',
    'US/Samoa'             : 'Pacific/Pago_Pago',

    // --- Country / region shortcuts ---
    'Cuba'      : 'America/Havana',
    'Egypt'     : 'Africa/Cairo',
    'Eire'      : 'Europe/Dublin',
    'GB'        : 'Europe/London',
    'GB-Eire'   : 'Europe/London',
    'Hongkong'  : 'Asia/Hong_Kong',
    'Iceland'   : 'Atlantic/Reykjavik',
    'Iran'      : 'Asia/Tehran',
    'Israel'    : 'Asia/Jerusalem',
    'Jamaica'   : 'America/Jamaica',
    'Japan'     : 'Asia/Tokyo',
    'Kwajalein' : 'Pacific/Kwajalein',
    'Libya'     : 'Africa/Tripoli',
    'NZ'        : 'Pacific/Auckland',
    'NZ-CHAT'   : 'Pacific/Chatham',
    'Navajo'    : 'America/Denver',
    'PRC'       : 'Asia/Shanghai',
    'Poland'    : 'Europe/Warsaw',
    'Portugal'  : 'Europe/Lisbon',
    'ROC'       : 'Asia/Taipei',
    'ROK'       : 'Asia/Seoul',
    'Singapore' : 'Asia/Singapore',
    'Turkey'    : 'Europe/Istanbul',
    'W-SU'      : 'Europe/Moscow',

    // --- UTC / GMT family (PHP's default list only accepts plain 'UTC') ---
    'GMT'            : 'UTC',
    'GMT0'           : 'UTC',
    'GMT+0'          : 'UTC',
    'GMT-0'          : 'UTC',
    'Greenwich'      : 'UTC',
    'UCT'            : 'UTC',
    'Universal'      : 'UTC',
    'Zulu'           : 'UTC',
    'Etc/UTC'        : 'UTC',
    'Etc/UCT'        : 'UTC',
    'Etc/Universal'  : 'UTC',
    'Etc/Zulu'       : 'UTC',
    'Etc/GMT'        : 'UTC',
    'Etc/GMT0'       : 'UTC',
    'Etc/GMT+0'      : 'UTC',
    'Etc/GMT-0'      : 'UTC',
    'Etc/Greenwich'  : 'UTC',

    // --- Legacy fixed-zone names (tzdata 2024b+ links them to these cities) ---
    'EST'     : 'America/Panama',
    'MST'     : 'America/Phoenix',
    'HST'     : 'Pacific/Honolulu',
    'EST5EDT' : 'America/New_York',
    'CST6CDT' : 'America/Chicago',
    'MST7MDT' : 'America/Denver',
    'PST8PDT' : 'America/Los_Angeles',
    'CET'     : 'Europe/Brussels',
    'MET'     : 'Europe/Brussels',
    'EET'     : 'Europe/Athens',
    'WET'     : 'Europe/Lisbon',
}